// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/pt';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // --- language ---
    fallbackLng: 'en',
    supportedLngs: ['en', 'pt'],
    // ensures "pt-PT" resolves to "pt" (so it loads /locales/pt.json)
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,

    // --- detection ---
    detection: {
      // ?lng= first: shared booking links carry the language the promoter
      // shared them in (see utils/applyLink.js).
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
      // optional key (default is "i18nextLng")
      lookupLocalStorage: 'i18nextLng',
    },

    // --- backend files ---
    backend: {
      loadPath: '/locales/{{lng}}.json',
      // avoids cached old JSON when debugging deployments
      queryStringParams: {
        v: process.env.REACT_APP_BUILD_VERSION || Date.now(),
      },
      // if you ever serve from a CDN path:
      // requestOptions: { cache: 'no-store' },
    },

    // --- react ---
    react: { useSuspense: true },

    // optional: reduce console noise
    debug: false,

    // recommended: escape handled by React
    interpolation: { escapeValue: false },
  });

// Keep moment's global locale in sync with i18n so dates formatted without an
// explicit `.locale()` call still follow the user's language.
const syncMomentLocale = (lng) => {
  moment.locale(lng && lng.startsWith('pt') ? 'pt' : 'en');
};
syncMomentLocale(i18n.language);
i18n.on('languageChanged', syncMomentLocale);

// <html lang> tells Google (and screen readers) which language the page is
// in. index.html ships "pt"; follow the visitor's choice from there.
const syncHtmlLang = (lng) => {
  document.documentElement.lang = lng && lng.startsWith('en') ? 'en' : 'pt';
};
if (i18n.language) syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
